import { render, staticRenderFns } from "./PortesEmpresas.vue?vue&type=template&id=795b70d6&scoped=true&"
import script from "./PortesEmpresas.vue?vue&type=script&lang=js&"
export * from "./PortesEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./PortesEmpresas.vue?vue&type=style&index=0&id=795b70d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b70d6",
  null
  
)

export default component.exports